import $ from 'jquery'

/**
 * Tracking handling mixin
 */
export default ({
  name,
  tracking = {}
}) => {
  return {
    props: {
      /**
       * Name used for tracking
       */
      formName: String
    },
    computed: {
      extendTrackingTransform() {
        return typeof tracking.submit === 'object' ? tracking.submit : {}
      },
      defaultDataLayer() {
        return {}
      },
      viewDataLayer() {
        return {
          ...this.defaultDataLayer,
        }
      },
      submitDataLayer() {
        return $.extend(true, this.viewDataLayer, {}, this.extendTrackingTransform)
      }
    },
    methods: {
      /**
       * @vuese
       * Track formView event
       */
      trackView() {
        if (!this.isSitecore && tracking.view) {
          this.$track(this.viewDataLayer)
        }
      },
      /**
       * @vuese
       * Track submit event
       * @arg Can be extended by implementing a extendSubmitTracking function that receives the response as a parameter
       */
      trackSubmit(data) {
        if (!this.isSitecore && tracking.submit) {
          let submitDataLayer = this.submitDataLayer
          if (typeof this.extendSubmitTracking === 'function') {
            submitDataLayer = $.extend(true, submitDataLayer, this.extendSubmitTracking(data))
          }
          this.$track(submitDataLayer)
          this.$track({ event: 'formSubmission' })
        }
      },
      /**
       * @vuese
       * Track validation errors event
       */
      trackValidationError(errors) {
        if (!this.isSitecore && tracking.validation) {
          this.$track({ ...this.defaultDataLayer, events: { error: true }, page: { errors }})
        }
      },
      /**
       * @vuese
       * Track external validation (Informatica) errors event
       */
      trackExternalValidationError(errors) {
        if (!this.isSitecore && tracking.externalValidation) {
          this.$track({ ...this.defaultDataLayer, events: { informaticaError: true }, page: { informaticaErrors: errors }})
        }
      },
      /**
       * @vuese
       * Track submit errors event
       */
      trackServerError() {
        if (!this.isSitecore && tracking.error) {
          this.$track({ ...this.defaultDataLayer, events: { error: true, formView: true, formSubmit: true }, page: { errors: this.serverErrors }})
        }
      }
    }
  }
}
